import { render, staticRenderFns } from "./DetailProject.vue?vue&type=template&id=7282fede&scoped=true&"
import script from "./DetailProject.vue?vue&type=script&lang=js&"
export * from "./DetailProject.vue?vue&type=script&lang=js&"
import style0 from "./DetailProject.vue?vue&type=style&index=0&id=7282fede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7282fede",
  null
  
)

export default component.exports